import { takeEvery, takeLatest } from 'redux-saga/effects';
import { ROLLBACK_VERSION_MODULE } from '../../../configs/moduleNames';
import {
  ROLLBACK_VERSION, LOAD_APPLICATION_HISTORY_VERSION_LIST,
  CREATE_ROLLBACK_PLANS,
  CHEK_STATUS_ROLLBACK_PLANS, LOAD_ROLLBACK_PLANS, CHEK_STATUS_ROLLBACK_PLANS_LOOP, LOAD_LOG_ROLLBACK_VERSION,
} from '../actions';

import createRollbackPlans from './createRollbackPlans';
import checkStatusRollbackVersion from './checkStatusRollbackVersion';
import loadRollbackPlans from './loadRollbackPlans';
import checkStatusRollbackPlansLoop from './checkStatusRollbackPlansLoop';
import rollbackVersion from './rollbackVersion';
import loadLogRollbackVersion from './loadLogRollbackVersion';
import loadVersionList from './loadVersionList';

export default function* watchDashboard() {
  yield takeLatest(ROLLBACK_VERSION_MODULE + LOAD_APPLICATION_HISTORY_VERSION_LIST, loadVersionList);
  yield takeEvery(ROLLBACK_VERSION_MODULE + CREATE_ROLLBACK_PLANS, createRollbackPlans);
  yield takeEvery(ROLLBACK_VERSION_MODULE + CHEK_STATUS_ROLLBACK_PLANS, checkStatusRollbackVersion);
  yield takeLatest(ROLLBACK_VERSION_MODULE + CHEK_STATUS_ROLLBACK_PLANS_LOOP, checkStatusRollbackPlansLoop);
  yield takeLatest(ROLLBACK_VERSION_MODULE + LOAD_ROLLBACK_PLANS, loadRollbackPlans);
  yield takeLatest(ROLLBACK_VERSION_MODULE + ROLLBACK_VERSION, rollbackVersion);
  yield takeEvery(ROLLBACK_VERSION_MODULE + LOAD_LOG_ROLLBACK_VERSION, loadLogRollbackVersion);
}
